module.exports = __webpack_public_path__ + "img/point-free-2.c79b478c.png";